import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxRow } from '@models/gift';
import { useFlow } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxRow;
}

function TransactionItem({ giftBox }:Props) {
    const {
        status, itemId, itemName, senderName, giftBoxType, receiverName, imageUrl, giftItemType,
    } = giftBox;
    const { t } = useTranslation('gift');
    const badge = (() => {
        switch (status) {
        case 'EXPIRED':
            return (<div className={styles.badge}>
                <Text size='s' fontWeight='bold'
                    color={colors.white}>{t('giftBox.status.expired')}</Text>
            </div>);
        case 'CANCELED':
            return (<div className={styles.badge}>
                <Text size='s' fontWeight='bold'
                    color={colors.white}>{t('giftBox.status.canceled')}</Text>
            </div>);
        case 'USED':
            return (<div className={styles.badgeUsed}>
                <Text size='s' fontWeight='bold'
                    color={colors.white}>{t('giftBox.status.used')}</Text>
            </div>);
        default:
            return <Fragment/>;
        }
    })();
    const { push } = useFlow();
    const handleClick = () => {
        if (giftBoxType === 'RECEIVED') {
            push('GiftReceivedActivity', { giftBoxItemId: itemId, giftItemType });
        } else {
            push('GiftSentActivity', { giftBoxItemId: itemId, giftItemType });
        }
    };
    return (<div className={styles.wrapper}
        onClick={handleClick} >
        <Column aria-label='transation-item'
            fullWidth
            className={styles.container}>
            <div className={`${styles.image} ${styles[`status-${status?.toLowerCase()}`]}`}>
                <Image src={imageUrl}
                    width={120}
                    height={120}
                    alt='' />
                {badge}
            </div>
            <Column className={styles.footer}
                fullWidth
                spacing={4}
                align='center'>
                <Text size='lg' fontWeight='bold'>{itemName}</Text>
                {giftBoxType === 'RECEIVED' && (
                    <Text>{t('giftBox.from', { name: senderName })}</Text>
                )}
                {giftBoxType === 'SENT' && (
                    <Text>{t('giftBox.to', { name: receiverName })}</Text>
                )}
            </Column>
        </Column>
    </div>);
}

export default TransactionItem;
